define([ // eslint-disable-line import/no-amd
  'react',
  'react-redux',
  'underscore',
  'JSON',
  'immutable',
  'lib/sumome/sumolist/formsync',
  'es6!sumo/util',
  'es6!156085c5-0017-4150-b225-a731ad248f38/service/form',
  'es6!launcher/util/listbuilder/wysiwyg/dom',
], (
  React,
  ReactRedux,
  _,
  JSON,
  Immutable,
  FormSync,
  Util,
  ListBuilderForm,
  WysiwygDom,
) => {
  const { FEATURES } = Util.Constants;

  class ScrollBoxPopup extends ListBuilderForm {
    constructor(service, settings) {
      super(service, settings);

      this.isClickEmitted = false;
      this.isFormSubmitted = false;

      this.receivePushApprovalResponse = this.receivePushApprovalResponse.bind(this);
    }

    close = () => {
      if (this.popupTimer) clearTimeout(this.popupTimer);
      const scaleEl = this.popupEl.querySelector('.scrollbox-popup-scale');
      const showPosition = this.settings.get('show_position');
      const slideDirection = this.settings.get('slide_direction');

      let sideToExit = 'top';
      let height = scaleEl.offsetHeight;
      let width = scaleEl.offsetWidth;

      if (showPosition.indexOf('bottom') !== -1 && slideDirection === 'up')
        sideToExit = 'bottom';
      else if (showPosition.indexOf('right') !== -1 && slideDirection === 'in')
        sideToExit = 'right';
      else if (showPosition.indexOf('left') !== -1 && slideDirection === 'in')
        sideToExit = 'left';

      if (!window.getComputedStyle(scaleEl).zoom) {
        // Doesn't support zoom, adjust height appropriately
        const transform = scaleEl.style.transform;
        const ratio = transform.indexOf('scale(') !== -1 ? parseFloat(transform.match(/scale\((.*)\)/)[1]) : 1;
        height = Math.ceil(height * ratio);
        width = Math.ceil(width * ratio);
      }

      // If the SumoBadge component is present, increase scrollbox height so badge doesn't linger
      // briefly on window edge when the popup is closed (also add an extra buffer amount)
      const sumoBadge = document.querySelector('.powered-by-sumo');
      if (sumoBadge) height += parseFloat(window.getComputedStyle(sumoBadge).height.match(/\d+/)) + 10;

      const offset = ['top', 'bottom'].indexOf(sideToExit) !== -1 ? `-${height}` : `-${width}`;
      scaleEl.style[sideToExit] = `${offset}px`;

      window.clearTimeout(this.closeTimeout);

      setTimeout(this.removeModal, 500);
      this.isShowing = false;

      // Check if user has a tab to show
      if (this.tabJson && this.tabJson.showType === 'after' && !this.tab) {
        this.showTab();
      }
    }

    show(ignoreYield) {
      const hasTrackingPixels = this.hasFeature(FEATURES.TRACKING_PIXELS);
      const popupId = this.settings.get('popup_id');
      const trackingPixels = this.settings.get('pixels_shown');
      const shouldYield = this.settings.get('yield');

      if (shouldYield && this.service.api.properties.yield && !ignoreYield) {
        console.log('Scroll Box is yielding...');
        return;
      }

      this.isShowing = true;

      // Set shown cookie
      setTimeout(() => this.service.setShownCookie(this), 0);

      this.service.api.emit('setProperties', { 'yield': true });

      if (this.service.shownPopups.indexOf(popupId) === -1) {
        this.logEvent('popup');
        this.service.shownPopups.push(popupId);
      }

      this.install();

      if (trackingPixels && hasTrackingPixels) {
        this.addTrackingPixels(trackingPixels, null, { id: 'tracking' });
      }
    }

    install() {
      // container
      this.popupEl = document.createElement('div');
      this.popupEl.className = 'sumo-form-wrapper scrollbox-popup';

      // content
      this.contentEl = document.createElement('div');
      this.contentEl.className = 'scrollbox-popup-content';
      this.popupEl.appendChild(this.contentEl);

      document.body.appendChild(this.popupEl);
      this.showStep(this.currentStep || 'subscribe');
    }
  }

  return ScrollBoxPopup;
});
